<template>
  <div class="navigation">
    <!-- HOME -->
    <router-link tag="a" :to="'/'+lng" active-class="active" exact>{{ t.home }}</router-link>
    <!-- ANNOUNCEMENTS -->
    <router-link
      tag="a"
      :to="`/${lng}/announcements/actual/${new Date().getFullYear()}`"
      :class="{active:pressClass('announcements')}"
    >{{t.announcement.menu }}</router-link>
    <!-- SEZENDEN -->
    <router-link tag="a" :to="`/${lng}/sezenden`" active-class="active">{{t.sezen}}</router-link>
    <!-- PRESSCLIPPINGS -->
    <router-link
      tag="a"
      :to="`/${lng}/press/${pressLink}`"
      :class="{active:pressClass('press')}"
    >{{t.press.pressTitle}}</router-link>
    <!-- ALL WORKS -->
    <router-link tag="a" :to="`/${lng}/all_works`" active-class="active">{{t.allWorks.menu}}</router-link>
    <!-- VIDEOS -->
    <router-link tag="a" :to="`/${lng}/videos`" active-class="active">{{t.videos}}</router-link>
    <!-- PHOTOS -->
    <router-link
      tag="a"
      :to="'/'+lng+'/photo_galleries/1'"
      :class="{active:pressClass('photo_galleries')}"
    >{{t.photos}}</router-link>
    <!-- CONTACT -->
    <router-link tag="a" :to="'/'+lng+'/contact'" active-class="active">{{t.contact.menu }}</router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["t", "lng"]),
    /**
     * Press URL correction for language
     * TR for 'press_clippings'
     * EN for 'foreign_press_clippings'
     */
    pressLink() {
      const pressType =
        this.lng !== "tr" ? "foreign_press_clippings" : "press_clippings";
      const queryParams = this.$store.state.press_dates_list[pressType].sort(
        (a, b) => {
          return b.to - a.to;
        }
      )[0];

      return (
        pressType +
        "/" +
        queryParams.from +
        "_" +
        (queryParams.to ? queryParams.to : "")
      );
    }
  },
  methods: {
    // button 'active' css correction for press link
    pressClass(value) {
      const reg = new RegExp(value);
      return reg.test(this.$route.path);
    }
  }
};
</script>

<style lang="scss">
</style>
